import { render, staticRenderFns } from "./ToznyForm.vue?vue&type=template&id=0c894ee5&"
import script from "./ToznyForm.vue?vue&type=script&lang=js&"
export * from "./ToznyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports